import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';

/**
 * Opt-out token for requests that shouldn't show the global
 * spinner (e.g. background polling, autosave):
 *
 *   this.http.get(url, {
 *     context: new HttpContext().set(SKIP_LOADING, true)
 *   });
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);




export const loadingInterceptor: HttpInterceptorFn = (req, next) => {

  const loading = inject(LoadingService);

  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  loading.start();

  return next(req).pipe(
    // finalize fires on success, error, AND cancellation —
    // the counter can never get stuck
    finalize(() => loading.stop())
  );
}; 